import { Injectable } from '@angular/core';
import { CarePaymentGridObject, CarePaymentObject } from '@libs/types/src/services/object-type/folder/care-payment.object';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from './types/filter.types';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';
import { CarePaymentUpdateInput, CarePaymentCreateInput } from '@libs/types/src/services/input-type/social/care-payment'

@Injectable({ providedIn: 'root' })
export class CarePaymentGqlServiceV2 extends GqlServiceV2 {

    public getCarePayments(input: GridInput | null, frag: string) {
        return this.query<CarePaymentGridObject>(
            `
                query($input: GridInput!) {
                    carePayment {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createCarePayment(input: CarePaymentCreateInput, frag: string) {
        return this.mutate<CarePaymentObject>(
            `
                mutation($input: CarePaymentCreateInput!) {
                    carePayment {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateCarePayment(input: CarePaymentUpdateInput, frag: string) {
        return this.mutate<CarePaymentObject>(
            `
                mutation($input: CarePaymentUpdateInput!) {
                    carePayment {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteCarePayment(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    carePayment {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
